import { get } from 'services/request';

export type IMemoryMeansTemplateOption = {
  id: number;
  label: string;
};

export default class MemoryMeansTemplateSelectModel {
  async get(emCount: 1 | 2 | 3) {
    return await get<IMemoryMeansTemplateOption[]>(`/memory/means-templates`, { em: emCount });
  }
}
